/**
 * Employee-only sidebar — single source of truth for role === employee.
 * Keeps self-service routes separate from HR/admin attendance modules.
 */

export const EMPLOYEE_WORKSPACE_ROUTES = {
  home: "/dashboard",
  attendance: "/my-attendance",
  leave: "/leave?tab=apply",
  leaveBalances: "/leave?tab=balances",
  compOff: "/leave/comp-off",
  encashment: "/leave/encashment",
  payslip: "/payslip",
  fuel: "/my-fuel",
  holidays: "/holiday-calendar",
  onboarding: "/my-onboarding",
  exit: "/my-exit",
};

/** Sidebar tree shown when the signed-in user has the employee role. */
export const EMPLOYEE_SIDEBAR_CONFIG = [
  {
    section: "My Workspace",
    roles: ["employee"],
    items: [
      {
        key: "emp_home",
        label: "Home",
        icon: "home",
        path: EMPLOYEE_WORKSPACE_ROUTES.home,
        color: "ic-blue",
        roles: ["employee"],
      },
      {
        key: "emp_att_my",
        label: "My Attendance",
        icon: "calendar",
        path: EMPLOYEE_WORKSPACE_ROUTES.attendance,
        color: "ic-teal",
        roles: ["employee"],
      },
      {
        key: "emp_leave_my",
        label: "My Leave",
        icon: "check-circle",
        path: EMPLOYEE_WORKSPACE_ROUTES.leave,
        color: "ic-blue",
        roles: ["employee"],
      },
      {
        key: "emp_leave_balances",
        label: "My Leave Balances",
        icon: "wallet",
        path: EMPLOYEE_WORKSPACE_ROUTES.leaveBalances,
        color: "ic-blue",
        roles: ["employee"],
      },
      {
        key: "emp_comp_off",
        label: "Comp Off",
        icon: "calendar-off",
        path: EMPLOYEE_WORKSPACE_ROUTES.compOff,
        color: "ic-amber",
        roles: ["employee"],
      },
      {
        key: "emp_encashment",
        label: "Encashment Request",
        icon: "wallet",
        path: EMPLOYEE_WORKSPACE_ROUTES.encashment,
        color: "ic-blue",
        roles: ["employee"],
      },
      {
        key: "emp_payslip",
        label: "My Payslip",
        icon: "file-text",
        path: EMPLOYEE_WORKSPACE_ROUTES.payslip,
        color: "ic-green",
        roles: ["employee"],
      },
      {
        key: "emp_fuel",
        label: "Fuel Reimbursement",
        icon: "fuel",
        path: EMPLOYEE_WORKSPACE_ROUTES.fuel,
        color: "ic-amber",
        roles: ["employee"],
      },
      {
        key: "emp_holidays",
        label: "Holiday Calendar",
        icon: "calendar-days",
        path: EMPLOYEE_WORKSPACE_ROUTES.holidays,
        color: "ic-amber",
        roles: ["employee"],
      },
      {
        key: "emp_my_onboarding",
        label: "My Onboarding",
        icon: "user-check",
        path: EMPLOYEE_WORKSPACE_ROUTES.onboarding,
        color: "ic-green",
        roles: ["employee"],
      },
      {
        key: "emp_my_exit",
        label: "My Exit",
        icon: "users",
        path: EMPLOYEE_WORKSPACE_ROUTES.exit,
        color: "ic-red",
        roles: ["employee"],
      },
    ],
  },
  {
    section: "Resources",
    items: [
      { key: "notice_board", label: "Notice Board", icon: "bell", path: "/noticeboard", color: "ic-amber" },
      { key: "help", label: "Help & Support", icon: "help-circle", path: "/help", color: "ic-slate" },
    ],
  },
];
